import GetPagedAzureProjectsListRequestModelBase from '../_generated/modelBases/get-paged-azure-projects-list-request-model-base';

export default class GetPagedAzureProjectsListRequestModel extends GetPagedAzureProjectsListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
